<template>
  <div
    class="ren-decoration-widget-box"
    :class="{
      'has-fixed-width': hasFixedWidth,
      'has-fixed-height': hasFixedHeight
    }"
    :style="boxStyle">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { widgetBoxStyle, widgetHasFixedSize } from './widget-style'

const props = defineProps<{
  styleSource?: Record<string, unknown> | null
}>()

const boxStyle = computed(() => widgetBoxStyle(props.styleSource))
const hasFixedWidth = computed(() => widgetHasFixedSize(props.styleSource, 'width'))
const hasFixedHeight = computed(() => widgetHasFixedSize(props.styleSource, 'height'))
</script>
